/* unplugin-vue-components disabled */import { render } from "./ChooseSpeach.vue?vue&type=template&id=1ffb946a&scoped=true&ts=true"
import script from "./ChooseSpeach.vue?vue&type=script&lang=ts"
export * from "./ChooseSpeach.vue?vue&type=script&lang=ts"

import "./ChooseSpeach.vue?vue&type=style&index=0&id=1ffb946a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffb946a"]])

export default __exports__